import { Button, HStack, Text } from "@chakra-ui/react";
import React, { memo, useCallback, useMemo } from "react";

import colors from "app/colors";
import { PencilIcon } from "modules/icons";
import { MessageFragment } from "gql/graphql";
import { useAuth } from "modules/providers/auth-provider";
import { useOverlay } from "modules/providers/overlay-provider";
import { MODAL_TYPE } from "modules/providers/overlay-provider/overlay-provider";

interface IProps {
  message: MessageFragment;
  displayText?: string;
}

const MessagePopoverEditMessageButton: React.FC<IProps> = ({
  message,
  displayText = "Edit Message",
}) => {
  const { openModal } = useOverlay();
  const { me } = useAuth();

  const openEditMessageModal = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      e.preventDefault();
      openModal({
        type: MODAL_TYPE.EDIT_MESSAGE,
        id: message.id,
      });
    },
    [message.id, openModal],
  );

  const isVisible = useMemo(
    () => me?.id === message.createdUserId,
    [me?.id, message.createdUserId],
  );

  if (!isVisible) {
    return null;
  }

  return (
    <Button variant="link" onClick={openEditMessageModal}>
      <HStack spacing={3}>
        <PencilIcon boxSize={5} fill={colors.blue} />
        <Text fontSize={14} color={colors.blackSecondary}>
          {displayText}
        </Text>
      </HStack>
    </Button>
  );
};

export default memo(MessagePopoverEditMessageButton);
